<template lang="html">
    <div id="page__stock__search" class="toolbar-search">
        <input 
            type="text" placeholder="Название склада..." v-model="filter.search"  class="toolbar-search__input"
            v-on:keyup="onSearchFilter" v-on:keyup.enter="onFilter"
        />
        <z-icon-button v-bind:icon="['fa', 'xmark']" rounded danger-light @click="onReset" v-bind:disabled="!hasFilter"></z-icon-button>
    </div>
</template>

<script>
	import ZIconButton from '@/components/ZIconButton.vue';
	export default {
		components: {ZIconButton},
		data() {
			return {
				filter: {
					search: null,
				},
				filterDefault: {
					search: null
				}
			}
		},
		created() {
			this.resolveQueryFilter();
		},
		computed: {
			/**
             * Показ кнопки удаления фильтра фильтра
             */
            hasFilter() {
                return Object.values(this.filter).some(item => !!item);
            }
		},
		methods: {
            /**
             * Подставление фильтра при перезагрузке
             */
            resolveQueryFilter() {
                if (!this.$route.query || !this.$route.query.filter) return
                this.filter = Object.assign({}, JSON.parse(this.$route.query.filter))
            },
			/**
             * Фильтрация по строке
             */
            onSearchFilter() {
                let search = this.filter.search
                setTimeout(() => {
                    if (search == this.filter.search) {
                        if (this.filter.search && this.filter.search.length > 2) this.onFilter();
                        else this.onReset();
                    }
                }, 1000)
            },
			/**
             * Фильрация
             */
            onFilter() {
                this.$router.push({
                    name: this.$route.name,
                    params: this.$route.params,
                    query: {
                        filter: JSON.stringify(this.filter)
                    }
                });
                this.$root.$emit('refresh-table', 'stocks');
            },
            /**
             * Сброс фильтра
             */
            onReset() {
                this.filter = Object.assign({}, this.filterDefault);
                let query = Object.assign({}, this.$route.query);
                delete query.filter;

                this.$router.push({
                    name: this.$route.name,
                    params: this.$route.params,
                    query: Object.assign({}, query)
                });
                this.$root.$emit('refresh-table', 'stocks');
            }
		}
	}
</script>



// WEBPACK FOOTER //
// SearchToolbar.vue?288ef30a